var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAugeIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 32,
    viewBox: "0 0 35 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_232_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.908 30.1081V13.3081L27.465 23.7131L21.576 24.7041L24.721 31.1161H34.709L17.355 -0.00292969L0.000976562 31.1161H20.955L18.508 26.1161L13.908 30.1081Z",
    fill: "#FF6F6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.574 24.7071L27.464 23.7161L13.907 13.311V30.1111L18.507 26.1271L20.954 31.1221H24.72L21.574 24.7071Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_232_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.708,
    height: 31.119,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAugeIco);
export default __webpack_public_path__ + "static/media/auge-ico.4c4fc55a2f0a1592d42f5b08e55c4c42.svg";
export { ForwardRef as ReactComponent };